import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "defaultModal",
  tabindex: "-1",
  class: "fixed top-0 left-0 right-0 bottom-0 z-50 w-full bg-gray-900 bg-opacity-50 p-xs lg:p-m overflow-x-hidden overflow-y-auto md:inset-0 max-h-full flex justify-center items-center overflow-scroll"
}
const _hoisted_2 = { class: "max-w-3xl w-full h-full" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-start justify-between p-4 border-b rounded-t"
}
const _hoisted_4 = { class: "text-xl font-semibold text-gray-900" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-3 h-3",
  "aria-hidden": "true",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Schliessen", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "pt-s lg:p-xs" }
const _hoisted_9 = {
  key: 1,
  class: "flex items-center justify-end p-6 space-x-2 border-t border-gray-200 rounded-b"
}

import { onMounted } from "vue";
import RoundedCard from "./RoundedCard.vue";
import UButton from "./UButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogCard',
  props: {
    isVisible: { type: Boolean },
    content: {},
    title: {},
    confirm: {},
    showFooter: { type: Boolean },
    onSubmit: {}
  },
  emits: ["close", "submit", "isReady"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

onMounted(() => {
  emit("isReady");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (props.isVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(RoundedCard, null, {
              default: _withCtx(() => [
                (props.title != undefined)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("h3", _hoisted_4, _toDisplayString(props.title), 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                      }, _hoisted_7)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_8, [
                  (_ctx.content !== undefined)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.content), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.$slots)
                    ? _renderSlot(_ctx.$slots, "default", { key: 1 })
                    : _createCommentVNode("", true)
                ]),
                (props.showFooter)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(UButton, {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
                        type: "button",
                        color: "white"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Abbrechen ")
                        ]),
                        _: 1
                      }),
                      _createVNode(UButton, {
                        onClick: _ctx.onSubmit,
                        type: "button",
                        class: "ml-s"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.confirm === undefined ? "Bestätigen" : props.confirm), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 3
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})